import axios from "axios";
import { NODE_BASE_URL, getAxiosOptions } from "./serviceHelper";

export const counterService = {
  getCount: async (
    user,
    counterFieldListId,
    pivotFieldListId,
    computedFieldId,
    currentProcessTemplateId,
    currentProcessReferenceNo
  ) => {
    return await axios.post(
      `${NODE_BASE_URL}/data-entry/process-data/compute-counter`,
      {
        counterFieldListId,
        pivotFieldListId,
        computedFieldId,
        currentProcessTemplateId,
        currentProcessReferenceNo,
      },
      getAxiosOptions(user)
    );
  },
};
